import { Form } from "@redriver/cinnamon-mui";
import { resourceRolesLookup } from "modules/lookups";

const ResourceRoleCheckboxGroup = (props) => (
  <Form.CheckboxGroup lookup={resourceRolesLookup} {...props} />
);

export default ResourceRoleCheckboxGroup;
